import React, { Fragment } from 'react'
import injectStyles from 'react-jss'
import cn from 'classnames'

import { styles } from './styles'
import { STEPS } from '../../options'

const Progress = ({ classes, step, hasSteps = false }) => {
  if (hasSteps) {
    delete STEPS.SUCCESS
  }

  return (
    <Fragment>
      <div
        className={cn(
          classes.stepsWrapper,
          step === STEPS.STEP_2 && classes.stepsWrapperStep2,
        )}
      >
        {Object.keys(STEPS).map(key => {
          return (
            <div
              key={key}
              className={cn(classes.step, key === step ? classes.active : null)}
            />
          )
        })}
      </div>
    </Fragment>
  )
}

export default injectStyles(styles)(Progress)
